<script setup lang="ts">
import { computed, CSSProperties, PropType } from "vue";
import { BcIconName } from "@/models";

defineOptions({ name: "BcIcon" });

const props = defineProps({
  name: { type: String as PropType<BcIconName> },
  color: { type: String },
  size: { type: String },
});

const menuStyle = computed<CSSProperties>(() => {
  return {
    "--icon-size": props.size,
    "--icon-color": props.color,
  };
});
</script>

<template>
  <div class="bc-icon" :style="menuStyle">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 210"
      v-if="props.name == 'sort-by-name-asc'"
    >
      <rect class="stroke" x="35.3" y="35.3" width="109.5" height="109.5" />
      <polygon
        class="stroke"
        points="144.8 81.7 144.8 144.8 81.7 144.8 81.7 174.7 174.7 174.7 174.7 81.7 144.8 81.7"
      />
      <path
        class="fill"
        d="M84.3,60.8h13l24.1,59.4h-14.3l-4.7-12.5h-23.7l-4.7,12.5h-13.7l24.1-59.4ZM98.6,97.5l-8.1-21.7-8.3,21.7h16.5Z"
      />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 210"
      v-else-if="props.name == 'sort-by-name-desc'"
    >
      <rect class="stroke" x="65.2" y="65.2" width="109.5" height="109.5" />
      <polygon
        class="stroke"
        points="65.2 128.3 65.2 65.2 128.3 65.2 128.3 35.3 35.3 35.3 35.3 128.3 65.2 128.3"
      />
      <path
        class="fill"
        d="M94.3,140.7l32.6-38.9h-30.9v-10.9h48.4v9.5l-32.6,38.9h32.6v10.9h-50.1v-9.5Z"
      />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 210"
      v-else-if="props.name == 'sort-by-value-asc'"
    >
      <line class="stroke" x1="119.6" y1="58.4" x2="152.4" y2="58.4" />
      <line class="stroke" x1="98.9" y1="89.5" x2="152.4" y2="89.5" />
      <line class="stroke" x1="78.3" y1="120.5" x2="152.4" y2="120.5" />
      <line class="stroke" x1="57.6" y1="151.6" x2="152.4" y2="151.6" />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 210"
      v-else-if="props.name == 'sort-by-value-desc'"
    >
      <line class="stroke" x1="119.6" y1="151.6" x2="152.4" y2="151.6" />
      <line class="stroke" x1="98.9" y1="120.5" x2="152.4" y2="120.5" />
      <line class="stroke" x1="78.3" y1="89.5" x2="152.4" y2="89.5" />
      <line class="stroke" x1="57.6" y1="58.4" x2="152.4" y2="58.4" />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 210"
      v-else-if="props.name == 'apply-filter'"
    >
      <polygon
        class="stroke"
        points="30.1 45 30.1 70.7 83.3 127.4 83.3 127.4 83.3 165 126.7 165 126.7 127.4 126.7 127.4 179.9 70.7 179.9 45 30.1 45"
      />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 210"
      v-else-if="props.name == 'sort-by-sort-id'"
    >
      <polyline class="stroke" points="125.5 170.3 170.3 170.3 170.3 125.5" />
      <polyline class="stroke" points="84.5 170.3 39.7 170.3 39.7 125.5" />
      <polyline class="stroke" points="125.5 39.7 170.3 39.7 170.3 84.5" />
      <polyline class="stroke" points="84.5 39.7 39.7 39.7 39.7 84.5" />
      <line class="stroke" x1="76.9" y1="75.8" x2="133.1" y2="75.8" />
      <line class="stroke" x1="76.9" y1="105" x2="133.1" y2="105" />
      <line class="stroke" x1="76.9" y1="134.2" x2="133.1" y2="134.2" />
    </svg>
  </div>
</template>

<style lang="less" scoped>
.bc-icon {
  width: var(--icon-size);

  svg {
    height: 100%;

    .fill {
      fill: var(--icon-color);
    }

    .stroke {
      fill: none;
      stroke: var(--icon-color);
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 12px;
    }
  }
}
</style>
